import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { createUrl } from '../../utils/url-utils'
import Img from 'gatsby-image'
import styles from './BlogPostList.module.css'

const BlogPostList = ({ blogPosts, shoeSlug }) => {
  return (
    <div className={styles.wrap}>
      <p className={styles.title}>Related Posts:</p>
      <ul className={styles.list}>
        {blogPosts.length > 0 &&
          blogPosts.map(
            ({ title, slug, createdAt, legacy, legacyTitle, category }) => (
              <li key={slug} className={styles.link}>
                <Link
                  to={`${createUrl(
                    legacy,
                    legacyTitle,
                    category,
                    title,
                    createdAt,
                    slug
                  )}#${shoeSlug}`}
                >
                  {title}
                </Link>
              </li>
            )
          )}
      </ul>
    </div>
  )
}

BlogPostList.propTypes = {
  blogPosts: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
  shoeSlug: PropTypes.string,
}

export default BlogPostList
